// src/api/index.js
import axios from "axios";

export const API_BASE =
  process.env.NODE_ENV === "production"
    ? "https://tawaf-1b75236a8328.herokuapp.com"
    : "http://localhost:8080";

const backend = axios.create({ baseURL: API_BASE });

// (optional) auth header from localStorage
backend.interceptors.request.use(
  (config) => {
    const raw = localStorage.getItem("user");
    if (raw) {
      const user = JSON.parse(raw);
      if (user?.token) {
        // merge, don't overwrite
        config.headers = { ...config.headers, Authorization: `Bearer ${user.token}` };
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default backend;
